// extracted by mini-css-extract-plugin
module.exports = {"toolMenu":"ei_selection_toolMenu__1Zki6"};